// IE 2026 11 01 / ODOO-349799 (sort-tree): быстрый проход apply_CHIPS (fast: строки берутся из кэша видимости _fe.visible) после пересортировки
// сгруппированного грида. wijmo при сортировке пересобирает группы (новые CollectionViewGroup без _fe) — строки-группы судятся заново и под
// глазом «Hide empty rows» признаются пустыми (у группы нет значений колонок), а строки данных идут из кэша и предков не оживляют (в полном
// проходе это делает цикл rows_root). Итог на dev02 01.11 (Configuration, чипс CHIP-Order «Count» поверх «Kind, Addon»): все 130 строк-групп
// visible=false, таблица пуста. Здесь — тот же подъём предков для кэшированной строки: видимая строка данных оживляет свои группы-родители.
// Выключатель fe.ux.gridFastPassGroupRevive (по умолчанию ВКЛ; false — поведение до правки: предки не оживляются).

export const FAST_PASS_GROUP_REVIVE_FLAG = 'fe.ux.gridFastPassGroupRevive'

export function fastPassGroupRevive_on(store) {
    try { return store?.setting?.(FAST_PASS_GROUP_REVIVE_FLAG, true) !== false } catch (e) { return true }
}

// Строка-группа в кэшированной ветке: её уровень — уровень группы; возвращает lastlevel для следующих строк данных
export function fastPass_groupSeen(rows_root, row, groupLevel) {
    const lvl = Number.isInteger(groupLevel) ? groupLevel : 0
    rows_root[lvl] = row
    return lvl
}

// Видимая строка данных из кэша оживляет группы-родители rows_root[0 .. lastlevel]; isOff(dataItem) — «выключенный родитель» (как в полном
// проходе: _hide_empty && _use_off). → число оживлённых строк
export function fastPass_reviveParents(rows_root, lastlevel, isOff) {
    let n = 0
    for (let level0 = 0; level0 <= lastlevel; level0++) {
        const parent = rows_root[level0]
        if (!parent) continue
        const parentDataItem = parent.dataItem
        if (isOff && isOff(parentDataItem)) continue
        if (parent.visible !== true) { parent.visible = true; n++ }
        if (parentDataItem && typeof parentDataItem === 'object') {
            if (!parentDataItem._fe) parentDataItem._fe = {}
            if (parentDataItem._fe.visible !== true) parentDataItem._fe.visible = true
        }
    }
    return n
}
